import { useParams } from "react-router-dom";
import AddAgentPage from "./add-agent";

export const EditAgentPage = () => {
  const { id } = useParams();

  return <AddAgentPage agentId={id} />;
};
